<template>
	<div class="navbar">
		<hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

		<breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

		<div class="right-menu">
			<template v-if="device!=='mobile'">
				<error-log class="errLog-container right-menu-item hover-effect" />

				<screenfull id="screenfull" class="right-menu-item hover-effect" />

				<el-tooltip content="全局显示大小" effect="dark" placement="bottom">
					<size-select id="size-select" class="right-menu-item hover-effect" />
				</el-tooltip>

			</template>

			<el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
				<div class="avatar-wrapper">
					<img :src="avatar" class="user-avatar">
					<i class="el-icon-caret-bottom" />
				</div>
				<el-dropdown-menu slot="dropdown">
					<router-link to="/">
						<el-dropdown-item>首页</el-dropdown-item>
					</router-link>
					<router-link to="/profile/index">
						<el-dropdown-item>个人中心</el-dropdown-item>
					</router-link>

					<el-dropdown-item divided @click.native="logout">
						<span style="display:block;">退出</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import Breadcrumb from '@/components/Breadcrumb'
	import Hamburger from '@/components/Hamburger'
	import ErrorLog from '@/components/ErrorLog'
	import Screenfull from '@/components/Screenfull'
	import SizeSelect from '@/components/SizeSelect'

	import User from '../../main'
	import Mgr from '../../services/SecurityService'

	export default {
		data(){
			return {
				user:User
			}
		},
		components: {
			Breadcrumb,
			Hamburger,
			ErrorLog,
			Screenfull,
			SizeSelect
		},
		computed: {
			...mapGetters(['sidebar', 'avatar', 'device'])
		},
		methods: {
			toggleSideBar() {
				this.$store.dispatch('app/toggleSideBar')
			},
			logout() {
				//console.log('user',this.user);
				//this.user.prototype.signOut();

				new Mgr().signOut();

				//await this.$store.dispatch('user/logout')
				//this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.navbar {
		height: 50px;
		overflow: hidden;
		position: relative;
		background: #fff;
		box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

		.hamburger-container {
			line-height: 46px;
			height: 100%;
			float: left;
			cursor: pointer;
			transition: background .3s;
			-webkit-tap-highlight-color: transparent;

			&:hover {
				background: rgba(0, 0, 0, .025);
			}
		}

		.breadcrumb-container {
			float: left;
		}

		.errLog-container {
			display: inline-block;
			vertical-align: top;
		}

		.right-menu {
			float: right;
			height: 100%;
			line-height: 50px;

			&:focus {
				outline: none;
			}

			.right-menu-item {
				display: inline-block;
				padding: 0 8px;
				height: 100%;
				font-size: 18px;
				color: #5a5e66;
				vertical-align: text-bottom;

				&.hover-effect {
					cursor: pointer;
					transition: background .3s;
				}

				&:hover {
					background: rgba(0, 0, 0, .025)
				}
			}

			.avatar-container {
				margin-right: 30px;

				.avatar-wrapper {
					margin-top: 5px;
					position: relative;

					.user-avatar {
						cursor: pointer;
						width: 25px;
						height: 25px;
						border-radius: 10px;
					}

					.el-icon-caret-bottom {
						cursor: pointer;
						position: absolute;
						right: -20px;
						top: 25px;
						font-size: 12px;
					}
				}
			}
		}
	}


</style>
